import { createFileRoute, redirect } from '@tanstack/react-router'

import { isAdminUser } from '@/lib/role-guards'
import { MemberInsightsPage } from '@/features/membership/insights'

export const Route = createFileRoute('/_authenticated/admin/insights')({
  beforeLoad: ({ context }) => {
    if (context.auth.isLoading) {
      return
    }
    if (!isAdminUser(context.auth.user)) {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: MemberInsightsPage,
})
